import { j as S } from "./jsx-runtime-3tyXYecC.mjs";
import { forwardRef as b, useContext as F } from "react";
import { F as h } from "./flex-Cc3osQLf.mjs";
import { u as v, F as z } from "./use-input-icon-Dk75O5Ch.mjs";
import { F as H } from "./field-context-CFgvjLYL.mjs";
import { f as j } from "./index-LyFokDcn.mjs";
import { m as w } from "./tss-DN0acMKN.mjs";
import { M as l, d as s } from "./constants-CnFYFetN.mjs";
const y = w({ name: "Label" })(({ typography: n, spacing: a, palette: e, mode: o, mixins: { fieldStatusColor: m } }, { status: r = "default", disabled: f, viewMode: M }) => {
  var c, u, g, x;
  const t = r !== "default" ? m(r, e) : e.gray[800];
  let i = e.gray[900];
  return f ? i = e.gray[600] : r !== "default" ? i = m(r, e) : M && (i = e.gray[700]), j.ifFeature(
    "encore",
    {
      root: {
        color: o === l.Dye ? s.main : i,
        fill: o === l.Dye ? s.main : i,
        fontSize: (c = n.small) == null ? void 0 : c.fontSize,
        fontWeight: n.fontWeightMedium,
        lineHeight: (u = n.small) == null ? void 0 : u.lineHeight,
        outline: o === l.Dye ? `1px solid ${s.main}` : void 0,
        position: "relative",
        transform: "none",
        whiteSpace: "wrap",
        "& > .MuiFormLabel-asterisk": {
          color: i,
          fontSize: (g = n.small) == null ? void 0 : g.fontSize,
          fontWeight: n.fontWeightMedium,
          lineHeight: (x = n.small) == null ? void 0 : x.lineHeight,
          marginLeft: "-3px"
        },
        "&.Mui-disabled": {
          color: i
        },
        "&.Mui-focused": {
          color: i
        },
        pointerEvents: "auto"
      }
    },
    {
      root: {
        display: "flex",
        alignItems: "center",
        fontSize: n.small.fontSize,
        whiteSpace: "nowrap",
        lineHeight: n.teenie.lineHeight,
        outline: o === l.Dye ? `1px solid ${s.main}` : void 0,
        "& > svg": {
          marginRight: a(0.75)
        },
        "& > .MuiFormLabel-asterisk": {
          color: f ? e.grey[600] : e.primary.main,
          marginLeft: a(0.5)
        },
        "&.Mui-disabled": {
          color: o === l.Dye ? s.lighter : e.grey[600]
        },
        "&.Mui-focused": {
          color: o === l.Dye ? s.main : t
        },
        pointerEvents: "auto",
        color: o === l.Dye ? s.main : t,
        fill: o === l.Dye ? s.main : t
      }
    }
  );
}), G = b(
  ({
    afterLabel: n,
    children: a,
    disabled: e,
    form: o,
    formId: m,
    htmlFor: r,
    inputId: f,
    isRequired: M,
    required: t,
    status: i,
    text: c,
    viewMode: u,
    ...g
  }, x) => {
    t = t ?? M;
    const L = F(H);
    L && (i = L.status, t = L.required, e = L.disabled);
    const { classes: D } = y({ disabled: e, status: i, viewMode: u }), d = v(i);
    return o = o ?? m, r = r ?? f, /* @__PURE__ */ S.jsxs(h, { alignItems: "center", columnGap: "4px", "data-fabric-component": "Label", children: [
      !e && d && /* @__PURE__ */ S.jsx(h, { marginRight: 0.5, children: d }),
      /* @__PURE__ */ S.jsxs(
        z,
        {
          className: D.root,
          disabled: e,
          error: i === "error",
          form: o,
          htmlFor: r,
          ref: x,
          required: t,
          ...g,
          children: [
            c,
            a
          ]
        }
      ),
      n
    ] });
  }
);
export {
  G as L
};
//# sourceMappingURL=label-BgzuHADZ.mjs.map
